import { __extends } from 'tslib';
import { ScriptLoader } from 'uitk-react-utils';
import { ThirdPartyAdapter } from './thirdparty-adapter.esm.js';
var PlacesServiceStatus;
(function (PlacesServiceStatus) {
  PlacesServiceStatus["INVALID_REQUEST"] = "INVALID_REQUEST";
  PlacesServiceStatus["OK"] = "OK";
  PlacesServiceStatus["OVER_QUERY_LIMIT"] = "OVER_QUERY_LIMIT";
  PlacesServiceStatus["REQUEST_DENIED"] = "REQUEST_DENIED";
  PlacesServiceStatus["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  PlacesServiceStatus["ZERO_RESULTS"] = "ZERO_RESULTS";
})(PlacesServiceStatus || (PlacesServiceStatus = {}));
var GoogleAdapter = /** @class */function (_super) {
  __extends(GoogleAdapter, _super);
  function GoogleAdapter(locale, apiKey) {
    var _this = _super.call(this, locale) || this;
    _this.url = "//maps.googleapis.com/maps/api/js?client=gme-expedia&channel=ess&libraries=places&language=".concat(locale, "&key=").concat(apiKey);
    _this.category = 'GOOGLEMAPS';
    _this.sourceName = 'GPA';
    _this.type = 'ADDRESS';
    ScriptLoader.getScript(_this.url).then(function () {
      _this.google = window.google;
      _this.initGooglePlacesService();
    }).catch(function (err) {
      console.error(err);
    });
    return _this;
  }
  GoogleAdapter.getInstance = function (locale, apiKey) {
    var thisLocale = locale || 'en_US';
    var thisGoogleApiKey = apiKey || 'AIzaSyABOFQNLMiTVN0AG3eWNmspVfVC8gNda68';
    if (!(thisLocale in this.instances)) {
      this.instances[thisLocale] = new GoogleAdapter(thisLocale, thisGoogleApiKey);
    }
    return this.instances[thisLocale];
  };
  GoogleAdapter.prototype.initGooglePlacesService = function () {
    if (this.google && this.google.maps && this.google.maps.places) {
      var AutocompleteService = this.google.maps.places.AutocompleteService;
      this.googleAutoCompleteService = new AutocompleteService();
    }
  };
  GoogleAdapter.prototype.fetchResults = function (essResponse) {
    var _this = this;
    var request = {
      input: essResponse.q,
      type: essResponse.rc === 'ADDRESS_AUTOCOMPLETE' ? ['geocode'] : undefined
    };
    var toEssResponse = function (results) {
      return {
        q: essResponse.q,
        rc: essResponse.rc,
        rid: essResponse.rid,
        sr: results
      };
    };
    return new Promise(function (resolve) {
      if (_this.googleAutoCompleteService) {
        _this.googleAutoCompleteService.getPlacePredictions(request, function (predictions, status) {
          if (status === PlacesServiceStatus.OK) {
            var response = toEssResponse(_this.handleResponse(predictions));
            resolve(response);
          } else {
            resolve(essResponse);
          }
        });
      } else {
        resolve(essResponse);
      }
    });
  };
  GoogleAdapter.prototype.handleResponse = function (predictions) {
    var _this = this;
    var results = [];
    predictions.forEach(function (prediction, index) {
      results.push(_this.toEssResult(prediction.description, prediction.place_id, index));
    });
    return results;
  };
  GoogleAdapter.instances = {};
  return GoogleAdapter;
}(ThirdPartyAdapter);
export { GoogleAdapter, PlacesServiceStatus };